import script from "./AnalyzeIelts.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyzeIelts.vue?vue&type=script&setup=true&lang=js"

import "./AnalyzeIelts.vue?vue&type=style&index=0&id=2524d092&lang=scss"

const __exports__ = script;

export default __exports__